import {FlexColumn, FlexItem, FlexRow, Label, TextField} from '@forecast-it/design-system';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import styled from 'styled-components';

type DropdownOptionItemProps = {
	value: string;
	errorText: string | null;
	isCreateNew?: boolean;
	onChange: (input: string) => void;
};

const StyledFlexColumn = styled(FlexColumn)`
	padding-top: 2px;
`;

export const DropdownOptionItem: React.FC<DropdownOptionItemProps> = ({value, onChange, children, errorText, isCreateNew}) => {
	return (
		<FlexRow>
			<FlexItem flex={'auto'}>
				<FlexColumn gap={'xs'}>
					<FlexRow>
						<Label size={'2'}>
							<FormattedMessage
								id={
									isCreateNew
										? 'settings.custom-fields.dropdown-options.edit_modal.dropdown_option_item.new_display_name'
										: 'settings.custom-fields.dropdown-options.edit_modal.dropdown_option_item.display_name'
								}
							/>
						</Label>
					</FlexRow>
					<FlexRow gap={'l'} alignItems={'start'}>
						<StyledFlexColumn>
							<TextField
								value={value}
								onValueChange={onChange}
								size="large"
								width="flex"
								errorText={errorText ?? undefined}
							/>
						</StyledFlexColumn>
						{children}
					</FlexRow>
				</FlexColumn>
			</FlexItem>
		</FlexRow>
	);
};
